export const SUPPORTED_LANGUAGES = ["en", "el", "de", "ru", "ua", "se"];
export const DEFAULT_LANGUAGE = "en";

function sanitizePathname(pathname = "/") {
  const path = String(pathname || "/").split("?")[0].split("#")[0];
  if (!path.startsWith("/")) {
    return `/${path}`;
  }
  return path || "/";
}

export function normalizeLanguage(language) {
  const normalized = String(language || "").toLowerCase();
  if (SUPPORTED_LANGUAGES.includes(normalized)) {
    return normalized;
  }
  return DEFAULT_LANGUAGE;
}

export function getLanguageFromPathname(pathname = "/") {
  const firstSegment = sanitizePathname(pathname).split("/").filter(Boolean)[0];
  if (!firstSegment) {
    return null;
  }
  const normalized = firstSegment.toLowerCase();
  return SUPPORTED_LANGUAGES.includes(normalized) ? normalized : null;
}

export function stripLanguageFromPathname(pathname = "/") {
  const segments = sanitizePathname(pathname).split("/").filter(Boolean);
  if (!segments.length) {
    return "/";
  }

  const firstSegment = segments[0].toLowerCase();
  if (SUPPORTED_LANGUAGES.includes(firstSegment) || /^[a-z]{2}$/.test(firstSegment)) {
    segments.shift();
  }

  return segments.length ? `/${segments.join("/")}` : "/";
}

export function getLocalizedPath(language, pathname = "/") {
  const lang = normalizeLanguage(language);
  const plainPath = stripLanguageFromPathname(pathname);
  return plainPath === "/" ? `/${lang}` : `/${lang}${plainPath}`;
}
